import React, { useState, FC } from "react";
import { Button } from "@UI/Components/Button/Button";
import { Icon } from "@UI/Components/Icon/Icon";
import messages from "./messages";
import { EuroCircle } from "@UI/Components/Icons/EuroCircle";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Box } from "@UI/Components/Box/Box";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { Stack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import { OfferPrice } from "@Shared/Components/OfferPrice/OfferPrice";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { ServiceOfferPreview } from "../../ServiceOfferPreview/ServiceOfferPreview";
import { IServiceOffer } from "../../../services/serviceOffers";

interface Props {
  serviceOffer: IServiceOffer;
}

export const CalculationModalWithToggle: FC<Props> = ({ serviceOffer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { currentUser } = useCurrentUser();
  const isSubscribed = currentUser?.subscribed ?? false;

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const isAcceptedVisitOffer =
    serviceOffer?.state === "accepted" && serviceOffer.rateType === "estimate";

  return (
    <Stack
      direction={isAcceptedVisitOffer ? "column" : "row"}
      justifyContent={isAcceptedVisitOffer ? "center" : "space-between"}
      pl="2"
      pb="3"
    >
      <Text
        fontWeight="bold"
        color="gray.800"
        fontSize={isAcceptedVisitOffer ? "lg !important" : "initial"}
        textAlign={isAcceptedVisitOffer ? "center" : "left"}
      >
        {isAcceptedVisitOffer ? (
          <>
            <FormattedMessage {...messages.visit} />{" "}
            <FormattedMessage {...messages.forQuote} />
          </>
        ) : (
          <FormattedMessage
            {...messages.offer}
            values={{
              offer: (
                <Box textAlign="right" as="span">
                  <OfferPrice
                    rateCents={serviceOffer.rateCents}
                    serviceFeesCents={serviceOffer.serviceFeesCents}
                    expenses={serviceOffer.expenses}
                    expensesFeesCents={serviceOffer.expensesFeesCents}
                    billingUnit={serviceOffer.billingUnit}
                    currency={serviceOffer.rateCurrency}
                    isSubscribed={isSubscribed}
                    colorScheme="candidateCard"
                  />
                </Box>
              ),
            }}
          />
        )}
      </Text>
      <Button
        fontSize="sm"
        variant="link"
        color="gray.700"
        onClick={handleToggle}
        display="flex"
        as="span"
        cursor="pointer"
        alignItems="center"
        _hover={{
          background: "none",
        }}
      >
        <Icon as={EuroCircle} marginRight="1" />
        <FormattedMessage {...messages.viewPriceEstimate} />
      </Button>
      <ResponsiveModal onClose={handleToggle} isOpen={isOpen}>
        <Box paddingBottom="4">
          <ServiceOfferPreview
            serviceOfferId={serviceOffer?.id}
            showServiceFees={true}
          />
        </Box>
      </ResponsiveModal>
    </Stack>
  );
};
